/* eslint-disable prettier/prettier */
import React from 'react';
import Styles from './RetrieveContract.module.css';
import Page from 'Common/Layout/Page';
import ActionButton from 'Common/Buttons/ActionButton';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import PropTypes from 'prop-types';
import { Input } from '@material-ui/core';
import DataTable from 'Common/Table/DataTable';
import Section from 'Common/Layout/Section';

const View = ({
    submit,
    setSearchId,
    data,
    onSelectionChange,
    isSelected,
    selectedRow,
    downloadContractPdf
}) => {

    const schema = [
        { field: "appointmentId", label: "Appointment ID" },
        { field: "contractGrouping", label: "Grouping" },
        { field: "displayType", label: "Type" },
        { field: "qualificationYear", label: "Qualification Year" }
	];

    let selected = false;

	const handleChange = (event) => {
		setSearchId(event.target.value);
	  }

	return (
        <Page title="Retrieve Contract and Terms">
            <Section>
                <h3 class="sr-only">Search</h3>
                <div className="container">
					<div className={Styles.formControl}>
						<p>Enter the appointee Id</p>
                        <Input type='text' onChange={handleChange} id="searchid-input" placeholder='Enter id'></Input>
						<ActionButton text="Search" onClick={submit} />
					</div>
				</div>
			</Section>
		
            <Section>
                <h3 class="sr-only">Search Results</h3>
				<div className="container">
					<DataTable
						dataSource={data}
						keyField="appointmentId"
						schema={schema}
						pagination
						selected={selected}
						selection
                        onSelectionChange={onSelectionChange}
					/>

					{isSelected && <p><strong>Selected appointment id :- {selectedRow.appointmentId}</strong></p>}

					{isSelected &&
							<ActionButton text="Retrieve" onClick={downloadContractPdf} />
					}
				</div>
			</Section>
		</Page>
	);
};

View.propTypes = {
	handleChange: PropTypes.func,
	data: PropTypes.array.isRequired,
	submit: PropTypes.func.isRequired,
	setSearchId: PropTypes.func.isRequired,
	onSelectionChange: PropTypes.func.isRequired,
	downloadContractPdf: PropTypes.func.isRequired,
	isSelected: PropTypes.bool.isRequired,
    selectedRow: PropTypes.any.isRequired
};
export default View;
